import { UseCase } from '../UseCase';
import { DashboardSkuGroup } from '../../models/DashboardSkuGroup';
import { SkuRepository } from '../../repositories/SkuRepository';

export class GetDashboardUseCase implements UseCase<undefined, Array<DashboardSkuGroup>>{

    constructor(
        private skuRepo: SkuRepository
    ) {

    }

    execute(t: undefined): Promise<DashboardSkuGroup[]> {
        return this.skuRepo.getDashboard();
    }

}